/** Static application metadata (localized primary strings live here). */
export const APP_NAME = "Взлёт талантов";
export const APP_NAME_EN = "VT Platform";
export const SUPPORT_EMAIL = "support@vzlettalantov.by";
